export const ITEMS_QNT_SHORT_MODE = 12;

export enum BrandsListLabels {
    SHOW_ALL_LABEL = "Показать все марки",
    SHOW_LESS_LABEL = "Показать меньше"
}